if (!customElements.get('product-share')) {
  customElements.define(
    'product-share',
    class ProductShare extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.copyButton = this.querySelector('[data-product-share-copy]');
        this.status = this.querySelector('[data-product-share-status]');
        this.resetTimer = null;

        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onCopy = this.copyLink.bind(this);

        document.addEventListener('click', this.onDocumentClick);
        this.addEventListener('keydown', this.onKeydown);
        this.copyButton?.addEventListener('click', this.onCopy);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.copyButton?.removeEventListener('click', this.onCopy);
        window.clearTimeout(this.resetTimer);
      }

      handleDocumentClick(event) {
        if (this.details?.open && !this.contains(event.target)) {
          this.details.open = false;
          this.clearStatus();
        }
      }

      handleKeydown(event) {
        if (event.key !== 'Escape' || !this.details?.open) return;

        this.details.open = false;
        this.clearStatus();
        this.details.querySelector('summary')?.focus();
      }

      async copyLink() {
        const url = this.copyButton?.dataset.copyUrl;
        if (!url) return;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url);
          } else {
            this.copyWithFallback(url);
          }

          this.status.textContent = 'Copy successfully！';
          this.copyButton.classList.add('is-copied');
          window.clearTimeout(this.resetTimer);
          this.resetTimer = window.setTimeout(() => this.clearStatus(), 2500);
        } catch (error) {
          this.status.textContent = 'Copy failed. Please try again.';
        }
      }

      copyWithFallback(url) {
        const input = document.createElement('textarea');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();

        const copied = document.execCommand('copy');
        input.remove();

        if (!copied) throw new Error('Copy command failed');
      }

      clearStatus() {
        if (this.status) this.status.textContent = '';
        this.copyButton?.classList.remove('is-copied');
      }
    }
  );
}
